import React from "react";
import Slider from 'react-slick';
import { getValidUrl } from "../helpers/url";

class ProductImage extends React.Component {
  state = {
    backgroundSize: 'contain'
  }

  handleMouseMove = e => {
    const { left, top, width, height } = e.target.getBoundingClientRect()
    const x = (e.pageX - left) / width * 100
    const y = (e.pageY - top) / height * 100
    this.setState({ backgroundPosition: `${x}% ${y}%`, backgroundSize: 'cover' })
  }

  handleMouseOut = e => {
    this.setState({ backgroundPosition: '50% 50%', backgroundSize: 'contain' })
  }

  render() {
    const { name, image } = this.props;
    let imageArray = [];
    let images = image.replace(' ', '').split(',');

    images.forEach(function (obj) {
      // Check if image ref is full Widen URL and use it. Otherwise, use locally stored images.
      imageArray.push(
        getValidUrl(obj) === true
          ? `${obj.replace(/\s+/g, '').toLowerCase()}`
          : `/wp-content/images/${obj.replace(/\s+/g, '').toLowerCase()}`
      );
    });

    if (imageArray.length > 1) {
      imageArray.shift();
    }

    const settings = {
      customPaging: function (i) {
        return (
          <div style={{ backgroundImage: `url(${imageArray[i]})` }} />
        );
      },
      dots: true,
      dotsClass: "slick-dots slick-thumb",
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className='product-carousel'>
        <h1>{name}</h1>
        <div className="product-image">
          <Slider
            {...settings}
            ref={c => (this.slider = c)}
          >
            {imageArray.map((slide, index) => (
              <div key={index} className="product-slide" onMouseMove={this.handleMouseMove} onMouseOut={this.handleMouseOut}>
                <div style={{ ...this.state, backgroundImage: `url(${slide})` }} className={index === 0 ? 'door-image' : ''} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default ProductImage;
